<template>
  <div>
    <label class="flex items-center text-left">
      <div class="w-12 flex justify-start">
        <input
          type="checkbox" class="w-5 h-5"
          v-model="checked">
      </div>
      <img
        v-if="item.image_path"
        :src="item.image_path"
        :alt="item.name"
        class="min-w-20 w-20 h-20 object-cover mr-4">
      <div class="w-full">
        <h3 class="text-lg">{{ item.name }} ({{ item.item_number }})</h3>
        <p v-if="!isDepositProduct">Stückzahl: <b>{{ item.pivot.quantity }}</b></p>
      </div>
    </label>
    <div v-show="checked" class="border-b border-gray-200 p-2 mb-2 pl-6">
      <!-- For deposit product -->
      <div v-if="isDepositProduct">
        <DepositForm
          :item="item"
          :deposit_difference="depositDifference"
          @update:deposit_difference="updateDepositDifference"
        />
      </div>

      <!-- For normal products -->
      <div v-if="!isDepositProduct" class="mb-2">
        <input
        type="checkbox"
        :id="'quantityIssue' + item.id"
        v-model="quantityIssue">
        <label :for="'quantityIssue' + item.id" class="ml-2">Menge</label>
      </div>
      <div v-if="!isDepositProduct && quantityIssue" class="sm:flex sm:justify-between my-2 pl-2">
        <div class="sm:mr-4">
          <select v-model="claimType" class="w-full sm:w-60 lg:w-48 h-10">
            <option disabled value="" class="text-gray-600">Typ wählen</option>
            <option value="less">Minderlieferung</option>
            <option value="more">Mehrlieferung</option>
          </select>
        </div>
        <div class="flex justify-between sm:justify-end items-center mt-4 sm:mt-0">
          <label class="mr-2 text-sm" :for="`product_actual_${item.id}`">Tatsächlich geliefert:</label>
          <input
            v-model.number="actual"
            :required="checked"
            class="w-14 h-10 p-0 px-1 text-center"
            type="number"
            :name="`product_actual_${item.id}`"
            :id="`product_actual_${item.id}`"
            :min="claimType === 'more' ? item.pivot.quantity + 1 : 0"
            :max="claimType === 'less' ? item.pivot.quantity - 1 : 999"
            placeholder="-">
        </div>
      </div>
      <div v-if="!isInRange" class="text-red-600 my-2 text-sm text-right mb-2">
        Bitte geben Sie eine Stückzahl zwischen 1 und 999 an.
      </div>
      <div v-if="!isDepositProduct" class="mb-2">
        <input
        type="checkbox"
        :id="'unsaleableIssue' + item.id"
        v-model="unsaleableIssue"
        @change="updateProductClaim">
        <label :for="'unsaleableIssue' + item.id" class="ml-2">Unverkäuflich</label>
      </div>
      <div v-if="!isDepositProduct && unsaleableIssue" class="mb-2 ml-5">
        <input
        type="checkbox"
        :id="'appearanceIssue' + item.id"
        v-model="appearanceIssue"
        @change="updateProductClaim">
        <label :for="'appearanceIssue' + item.id" class="ml-2">Optik</label>
      </div>
      <div v-if="!isDepositProduct && unsaleableIssue" class="mb-2 ml-5">
        <input
        type="checkbox"
        :id="'tasteIssue' + item.id"
        v-model="tasteIssue"
        @change="updateProductClaim">
        <label :for="'tasteIssue' + item.id" class="ml-2">Geschmack</label>
      </div>
    </div>
  </div>
</template>

<script>
import DepositForm from '@/Components/Complaint/DepositForm'

export default {
  name: 'OrderPosition',
  components: {DepositForm},
  props: {
    item: {
      type: Object,
      required: true
    },
    isDepositProduct: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    checked: false,
    claimType: 'less',
    actual: null,
    quantityIssue: false,
    unsaleableIssue: false,
    appearanceIssue: false,
    tasteIssue: false,
    depositDifference: null,
    isInRange: true,
    isActualQuantityValid: true,
  }),

  watch: {
    checked: function(val) {
      if (!val) {
        this.$emit('remove')

        this.quantityIssue = false
        this.actual = null
        this.unsaleableIssue = false
        this.appearanceIssue = false
        this.tasteIssue = false
        this.depositDifference = null
      } else {
        this.updateProductClaim()
      }
    },

    unsaleableIssue: function(val) {
      if (!val) {
        this.appearanceIssue = false
        this.tasteIssue = false
      }
    },

    quantityIssue: function(val) {
      if (this.checked && !val) {
        this.actual = null
      }

      this.updateProductClaim()
    },

    actual: function(val) {
      if (this.checked) {
        this.validateIsInRange()
        this.updateProductClaim()
      }
    },
  },

  methods: {
    validateIsInRange() {
      if (this.actual > 999) {
        this.actual = 999
        this.isInRange = false
      } else if (this.actual < 999) {
        this.isInRange = true
      }
    },

    updateProductClaim() {
      this.$nextTick(() => {
        if (this.checked) {
          if (this.isDepositProduct) {
            this.$emit('update', {
              id: this.item.id,
              difference: this.depositDifference,
            })
          } else {
            this.$emit('update', {
              id: this.item.id,
              quantityIssue: this.quantityIssue,
              quantity: this.item.pivot.quantity,
              actual: this.actual,
              unsaleable: this.unsaleableIssue,
              appearance: this.appearanceIssue,
              taste: this.tasteIssue,
            })
          }
        }
      })
    },

    updateDepositDifference(newValue) {
      this.depositDifference = newValue
      this.updateProductClaim()
    },
  }
}
</script>
